












import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringCardWrapper } from '../components';
import MentoringRequestCard from '../requestcard';
import { IMentoringRequestList, Requests } from './types';

@Component({
  components: {
    MentoringCardWrapper,
    MentoringRequestCard,
  },
})
export default class MentoringRequestList extends Vue
  implements IMentoringRequestList {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Requests;

  @Prop({ type: Number, default: 2 })
  readonly step!: number;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/requestslist/MentoringRequestList.vue